import moment from "moment";
import { FORMAT } from "web/components/utils/dateOfBirthValidation";
import React from "react";

const Summary = ({postDetail}) => {

  const capitalize = (s) => {
    if (typeof s !== 'string')
      return ''
    return s.charAt(0).toUpperCase() + s.slice(1)
  }
  const gradeSize = () => {
    let commodityDim = "";
    if (
      postDetail?.palletDetails?.length &&
      postDetail?.palletDetails?.width &&
      postDetail?.palletDetails?.height
    ) {
      let length = postDetail?.palletDetails?.length;
      let width = postDetail?.palletDetails?.width;
      let height = postDetail?.palletDetails?.height;
      commodityDim = length + "x" + width + "x" + height;    
    } else {
      if (postDetail?.palletDetails?.size) {
        commodityDim = capitalize(postDetail?.palletDetails?.size.toLowerCase());
      }else{
        if (postDetail?.palletDetails?.grade && postDetail?.palletDetails?.gradeName) {
          commodityDim = capitalize(postDetail?.palletDetails?.gradeName.toLowerCase());
        }
      }    
    }
    return commodityDim;
  };

  const getGradeName = () => {
    let gradeName = "";
    if (postDetail?.palletDetails?.grade) {
      gradeName = postDetail?.palletDetails?.grade;
    }

    return gradeName;
  };

  const getCommodity = () => {
    let commodityVal = "";
    if (postDetail?.palletDetails?.palletType) commodityVal = capitalize(postDetail?.palletDetails?.palletType.toLowerCase()) 
    else if (postDetail?.palletDetails?.material === 'PLASTIC') commodityVal = 'Plastic'
    else if (postDetail?.palletDetails?.material === 'OTHER') commodityVal = 'Custom'
    return commodityVal;
  };

  const getMoisture = () => {
    let moistureVal = "";
    if (postDetail?.palletDetails?.moisture) {
      moistureVal = postDetail?.palletDetails?.moisture;
    }
    return capitalize(moistureVal.toLowerCase());
  };

  let requestDate = "";
  if (postDetail.requestedDate) {
    // requestDate =moment(new Date(postDetail?.requestedDate * 1000).toLocaleString()).format(FORMAT)
    requestDate = moment(postDetail?.requestedDate).format(FORMAT)
  }

  const tConvert = (time) => {
    if (time) {
      time = time
        .toString()
        .match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];

      if (time.length > 1) {
        time = time.slice(1);

        time[3] = undefined // removing the seconds
        time[5] = +time[0] < 12 ? " AM" : " PM"; // Set AM/PM
        // time[3] = +"";
        // time[2] = +"";
        time[0] = +time[0] % 12 || 12; // Adjust hours
      }
      return time.join("");
    }
  };

  //updated for need-delivery-request-appointment-case
  const getTimings = () => {
    if(postDetail?.appointmentStartTime && postDetail?.appointmentEndTime){      
      //return `${postDetail?.appointmentStartTime} - ${postDetail?.appointmentEndTime}`; 
      return `${tConvert(postDetail?.appointmentStartTime)} - ${tConvert(postDetail?.appointmentEndTime)}`; 
    }else{
      if(postDetail?.appointmentStartTime){
        // let formattedTime = postDetail?.appointmentStartTime.split(":");
        // formattedTime = `${formattedTime[0]}:${formattedTime[1]}`;
        return tConvert(postDetail?.appointmentStartTime);
      }
    }
     
  }

  const getDeliveryMode = () => {
    let mode = "";
    if(postDetail?.postType === "NEED"){
      if(postDetail?.shippingMode !== 'DELIVERY'){
        mode = "Pickup"
      }else{
        mode = "Delivery"
      }
    }else{
      if(postDetail?.shippingMode === 'DELIVERY'){
        mode = "Delivery"
      }else{
        mode = "Pickup"
      }
    }
    return mode;
  }

  const getQty = () => {
    return postDetail?.quantity;
  }
  
  return (
    <p style={{fontWeight: "bold", fontSize: '16px', marginTop: '10px', textAlign: 'left'}}>
      Post Summary Details: {getQty()} {gradeSize()} {getCommodity()}, {getMoisture()} {getGradeName()} Pallets for {getDeliveryMode()} on {requestDate} {getTimings()}
    </p>
  )
}
export default Summary;